<template>
  <div id="moinitoring">
    <vue-loading :active.sync="loading" :is-full-page="true" loader="dots" color="#70A1F0"></vue-loading>

    <nav class="navbar fixted-top navbar-light bg-light" v-if="active != null">
      <div class="navbar-brand">Monitoring</div>
      <ul class="nav nav-pages mr-auto">
        <li class="nav-item">
          <a class="nav-link" :class="{'active': true}" type="button">Recommended</a>
        </li>
      </ul>

      <div class="nav-item btn-group dropdown">
        <button type="button" class="btn-block btn dropdown-toggle btn-secondary text-right" style="margin-right: 10px;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{active.account_name}}
        </button>
        <div class="dropdown-menu dropdown-menu-right scrollable-menu">
          <h6 class="dropdown-header">Accounts</h6>
          <div v-for="report in monitoring" :key="report.account">
            <a class="dropdown-item" @click="active=report">{{ report.account_name }}</a>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-primary text-right" @click="downloadCSV">Download Report</button>
    </nav>

    <div class="row" v-if="active != null">
      <div class="col">
        <div class="row">
          <transition name="fade" appear>
            <div class="card col">
              <div class="card-heading">
                <h4>Account</h4>
              </div>
              <div class="card-body">
                <dl>
                  <dt>Contract</dt><dd>{{active.contract}}</dd>
                  <dt>Account Name</dt><dd>{{active.account_name}}</dd>
                  <dt>Account Id</dt><dd>{{active.account}}</dd>
                  <dt>Guardian Alarms</dt><dd>{{countAlarms('MetricAlarms')}}</dd>
                </dl>
                <div class="progress" style="height: 25px; margin-top: 10px;">
                  <span class="progress-text">{{alarmCoverage()}}% Alarm Coverage</span>
                  <div class="progress-bar bg-success" role="progressbar" :style="{'width': alarmCoverage() +'%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                  <div class="progress-bar bg-danger" role="progressbar" :style="{'width': (100 - alarmCoverage()) +'%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div class="row">
          <transition name="fade" appear>
            <div class="card col" v-if="activeResource != null">
              <div class="card-heading">
                <h4>Metric Resource</h4>
              </div>
              <div class="card-body">
                <dl class="metric-details">
                  <dt>Namespace</dt>
                  <dd>{{activeResource.Namespace}}</dd>
                  <dt>Metric Name</dt>
                  <dd>{{activeResource.MetricName}}</dd>
                  <dt>Monitoring Rating</dt>
                  <dd>{{activeResource.MonitoringRating}}</dd>
                  <dt>Resource Name</dt>
                  <dd>{{getResourceName(activeResource)}}</dd>
                  <dt>Resource Type</dt>
                  <dd>{{getResourceType(activeResource)}}</dd>
                </dl>
                <h5 style="margin-top: 10px;">Dimensions</h5>
                <dl class="dimensions">
                  <div v-for="dimension in activeResource.Dimensions" :key="dimension.Name">
                    <dt>{{dimension.Name}}</dt>
                    <dd>{{dimension.Value}}</dd>
                  </div>
                </dl>
                <h5 style="margin-top: 10px;">Description</h5>
                <p>{{activeResource.Documentation.Description}}</p>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div class="col-9">
        <transition name="fade" appear>
          <vue-good-table
            :columns="metricTableColumns"
            :rows="active.metric_alarms"
            @on-row-click="onRowClick"
            :search-options="{
              enabled: true,
              skipDiacritics: true,
              placeholder: 'filter',
            }"
            :pagination-options="{
              enabled: true,
              perPage: 15,
            }"
            :row-style-class="rowStyleClassFn"
            styleClass="vgt-table condensed">
            <div slot="table-actions">
              <button type="button" class="btn btn-danger btn-margin btn-sm" @click="showMissingAlarmsRows">Show Missing</button>
              <button type="button" class="btn btn-success btn-margin btn-sm" @click="showAllAlarmsRows">Show All</button>
            </div>
          </vue-good-table>
        </transition>
      </div>
    </div>

    <div class="row" v-if="active != null && activeResource != null">
      <transition name="fade" appear>
        <div class="col">
          <h4>Recommended Alarms</h4>
          <vue-good-table
            :columns="recommendedAlarmsTableColumns"
            :rows="activeResource.RecommendedAlarms"
            styleClass="vgt-table condensed">
          </vue-good-table>
        </div>
      </transition>
    </div>

    <div class="row" v-if="active != null && activeResource != null">
      <transition name="fade" appear>
        <div class="col">
          <h4>Metric Alarms</h4>
          <vue-good-table
            :columns="metricAlarmsTableColumns"
            :rows="activeResource.MetricAlarms"
            styleClass="vgt-table condensed">
          </vue-good-table>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import HTTP from '@/common/http'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'monitoring',
  props: [
    'id'
  ],
  components: {
    VueLoading
  },
  data () {
    return {
      loading: false,
      monitoring: {},
      active: null,
      selectedRow: 0,
      metricTableColumns: [
        {
          label: 'Resource Name',
          field: this.getResourceName
        },
        {
          label: 'Resource Type',
          field: this.getResourceType
        },
        {
          label: 'Namespace',
          field: 'Namespace'
        },
        {
          label: 'Metric Name',
          field: 'MetricName'
        },
        {
          label: 'Monitoring Rating',
          field: 'MonitoringRating'
        },
        {
          label: 'Recommended Alarms',
          field: this.countRecommendedAlarms
        },
        {
          label: 'Metric Alarms',
          field: this.countMetricAlarms
        }
      ],
      activeResource: null,
      recommendedAlarmsTableColumns: [
        {
          label: 'Id',
          field: 'Id'
        },
        {
          label: 'ComparisonOperator',
          field: 'ComparisonOperator'
        },
        {
          label: 'Statistic',
          field: 'Statistic'
        },
        {
          label: 'Threshold',
          field: 'Threshold'
        },
        {
          label: 'EvaluationPeriods',
          field: 'EvaluationPeriods'
        },
        {
          label: 'Period',
          field: 'Period'
        },
        {
          label: 'TreatMissingData',
          field: 'TreatMissingData'
        },
        {
          label: 'AlarmActions',
          field: 'AlarmActions'
        }
      ],
      metricAlarmsTableColumns: [
        {
          label: 'AlarmName',
          field: 'AlarmName'
        },
        {
          label: 'ActionsEnabled',
          field: 'ActionsEnabled'
        },
        {
          label: 'AlarmActions',
          field: 'AlarmActions'
        },
        {
          label: 'OKActions',
          field: 'OKActions'
        },
        {
          label: 'ComparisonOperator',
          field: 'ComparisonOperator'
        },
        {
          label: 'EvaluationPeriods',
          field: 'EvaluationPeriods'
        },
        {
          label: 'Period',
          field: 'Period'
        },
        {
          label: 'DatapointsToAlarm',
          field: 'DatapointsToAlarm'
        },
        {
          label: 'Statistic',
          field: 'Statistic'
        },
        {
          label: 'Threshold',
          field: 'Threshold'
        },
        {
          label: 'TreatMissingData',
          field: 'TreatMissingData'
        }
      ]
    }
  },
  methods: {
    getData: function () {
      this.loading = true
      HTTP.get(`monitoring/contract/${this.id}`)
        .then((response) => {
          this.monitoring = response.data.monitoring
          this.active = response.data.monitoring[0]
          this.activeResource = this.active.metric_alarms[0]
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to get monitoring report : ${error.message}`
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadCSV: function () {
      this.flashMessage.info({
        message: 'Genrating monitoring CSV report',
        time: 3000
      })
      HTTP.get(`/monitoring/contract/${this.id}/csv`)
        .then((response) => {
          window.location = response.data.signedUrl
          this.flashMessage.success({
            message: 'Monitoring CSV report generation complete'
          })
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to generate monitoring CSV report : ${error.message}`
          })
        })
    },
    onRowClick: function (params) {
      this.activeResource = params.row
      this.selectedRow = params.row.originalIndex
    },
    checkActive: function (accountId) {
      return accountId === this.active.account
    },
    getResourceName: function (rowObj) {
      var resource = Object.values(rowObj.ResourceNames)
      console.log('TAG: ' + resource[0])
      if (resource[0] != null) {
        return resource[0].Tag
      }
      return ''
    },
    getResourceType: function (rowObj) {
      var resource = Object.values(rowObj.ResourceNames)
      if (resource[0] != null) {
        return resource[0].Resource
      }
      return ''
    },
    countRecommendedAlarms: function (rowObj) {
      return rowObj.RecommendedAlarms.length
    },
    countMetricAlarms: function (rowObj) {
      return rowObj.MetricAlarms.length
    },
    rowStyleClassFn: function (rowObj) {
      if (rowObj.originalIndex === this.selectedRow) {
        return 'selected-row'
      } else if (rowObj.RecommendedAlarms.length > rowObj.MetricAlarms.length) {
        return 'highlight-row-red'
      } else {
        return 'highlight-row-green'
      }
    },
    countAlarms: function (type) {
      var count = 0
      for (var i in this.active.metric_alarms) {
        count += this.active.metric_alarms[i][type].length
      }
      return count
    },
    alarmCoverage: function () {
      const metricAlarms = this.countAlarms('MetricAlarms')
      console.log('MetricAlarms = ' + metricAlarms)
      const recommendedAlarms = this.countAlarms('RecommendedAlarms')
      console.log('RecommendedAlarms = ' + recommendedAlarms)
      return Math.ceil((metricAlarms / recommendedAlarms) * 100)
    },
    showMissingAlarmsRows: function () {
      var newActive = {
        account: this.active.account,
        metric_alarms: [],
        missing_metrics: [],
        account_name: this.active.account_name,
        contract: this.active.contract
      }
      for (var i in this.active.metric_alarms) {
        if (this.active.metric_alarms[i].RecommendedAlarms.length > this.active.metric_alarms[i].MetricAlarms.length) {
          newActive.metric_alarms.push(this.active.metric_alarms[i])
        }
      }
      this.active = newActive
    },
    showAllAlarmsRows: function () {
      for (var i in this.monitoring) {
        if (this.monitoring[i].account === this.active.account) {
          this.active = this.monitoring[i]
        }
      }
    }
  },
  watch: {
    id: function () {
      this.monitoring = {}
      this.selectedRow = 0
      this.active = null
      this.activeResource = null
      this.getData()
    }
  },
  created: function () {
    this.getData()
  }
}
</script>

<style scoped>
.row {
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
}

ul.nav a {
  color: rgba(0, 0, 0, 0.5);
}

ul.nav a:hover {
  cursor: pointer;
  color: rgba(0, 0, 0, 1);
}

.active {
  color: rgba(0, 0, 0, 0.8) !important;
}

.card {
  transition: opacity 200ms;
  background: #ffffff;
  width: auto;
  padding: 15px 15px 15px 15px;
  border: none;
  border-radius: 0;
  box-sizing: content-box;
  box-shadow: 0 2px 13px -5px rgba(0,0,0,0.2);
}

.btn-margin {
  margin-right: 10px;
}

.progress-text {
  position: absolute !important;
  justify-content: center !important;
  display: flex !important;
  color: white;
  font-weight: 500;
  font-size: 1.2em;
  width: 90%;
}

.metric-details {
  display: grid;
  grid-template-columns: max-content auto;
  margin: 0px;
}

h4 {
  padding-bottom: 5px;
}

dt {
  font-weight: 600;
  margin-bottom: 2px;
  grid-column-start: 1;
  margin-right: 10px;
}

dd {
  margin-bottom: 2px;
  grid-column-start: 2;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 200ms ease-in-out;
}
.fade-enter-to {
  opacity: 1;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Monitoring.vue